import { invokeIf } from 'aem-libs-react-ts/src/utils/conditionalInvoke'
import { createTestId } from 'aem-libs-tests/src/utility/createTestId'

import * as ToggleButtonStyled from './ToggleButtonItem.styled'
import type { ToggleButtonItemType, ToggleButtonValueType } from './types'

interface ToggleButtonItemProps<TValue extends ToggleButtonValueType> extends ToggleButtonItemType<TValue> {
  role: 'radio' | 'checkbox'
  tabIndex: number
  isActive: boolean
  onClick: (value: TValue) => void
  testId: string
  id: string
}

export function ToggleButtonItem<TValue extends ToggleButtonValueType>({
  isActive,
  value,
  label,
  disabled,
  onClick,
  role,
  tabIndex,
  testId,
  id,
  renderLabel
}: ToggleButtonItemProps<TValue>) {
  const handleClickItem = () => invokeIf(!disabled, onClick, [value])

  return (
    <ToggleButtonStyled.Container
      onClick={handleClickItem}
      onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && handleClickItem()}
      id={id}
      aria-checked={isActive}
      role={role}
      $isActive={isActive}
      tabIndex={tabIndex}
      data-testid={createTestId(testId, typeof value === 'string' ? value : value.toString())}
    >
      <ToggleButtonStyled.Label data-testid={createTestId(testId, `${id}-label`)} aria-label={label}>
        {renderLabel ? renderLabel() : label}
      </ToggleButtonStyled.Label>
      {isActive && <ToggleButtonStyled.ActiveIco />}
    </ToggleButtonStyled.Container>
  )
}
